module.exports = __webpack_public_path__ + "img/comment-middle.219374db.svg";